<template>
  <div
    v-if="sourceType"
    class="d-inline-block"
  >
    <v-chip
      :color="sourceType.Status ? 'green' : ''"
      :dark="sourceType.Status"
      :small="dense"
      :style="`min-width: ${chipMinWidth}px; min-height: ${chipMinHeight}px;`"
      class="pl-0"
      label
    >
      <v-avatar
        :color="sourceType.Avatar.Color"
        :style="avatarSize"
        class="mr-2"
        tile
      >
        <v-icon
          v-if="sourceType.Avatar.Icon"
          :size="iconSize"
          class="white--text"
        >
          {{ sourceType.Avatar.Icon }}
        </v-icon>

        <img
          v-else
          :src="sourceType.Avatar.Img"
          :width="`${iconSize}px`"
          height="auto"
        >
      </v-avatar>

      <div
        class="text-center"
        style="width: 100%;"
      >
        {{ sourceType.Name }}
      </div>
    </v-chip>
  </div>
</template>

<script>

import SourceType from '@/mixins/orders/sourceType'

export default {
  name      : 'OrderSourceTypeChip',
  components: {},
  directives: {},
  mixins    : [SourceType],
  props     : {
    sourceType: {
      type   : Object,
      default: undefined
    },
    minWidth: {
      type   : [Number, String],
      default: 180
    },
    minHeight: {
      type   : [Number, String],
      default: 32
    },
    dense: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    chipMinWidth() {
      return this.minWidth.toString().replaceAll('px', '')
    },
    chipMinHeight() {
      return this.minHeight.toString().replaceAll('px', '')
    },
    iconSize() {
      return this.dense ? 18 : 22
    },
    avatarSize() {
      return `width: ${this.dense ? 32 : 46}px !important; height: ${this.chipMinHeight}px !important;`
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>
:deep(.v-chip > .v-chip__content) {
  width: 100%;
}
</style>
